import { z } from 'zod';

/**
 * consumer-web's Square card form page (`/square-card-form`), which consumer-native shows in a
 * WebView to add a card at a Square venue: Square's Web Payments SDK only runs in a secure context,
 * so the app loads it from consumer-web over HTTPS rather than from its own bundle.
 *
 * The page takes `applicationId` and `locationId` in its query string, and talks to the app only
 * through these messages (`window.ReactNativeWebView.postMessage`, JSON). The app calls the
 * page's `window.tokenizeSquareCard()` when the customer saves, and saves the nonce itself
 * (`consumerNative.addCard`), so the page needs no sign-in.
 *
 * Frozen: shipped app builds read these messages, and the page deploys without them.
 */
export const squareCardFormMessageSchema = z.discriminatedUnion('type', [
  /** The card form is showing and can tokenize. */
  z.object({ type: z.literal('ready') }),
  /** The card's nonce, for the server to save on the customer's Square customer. */
  z.object({ type: z.literal('tokenized'), squareCardNonce: z.string() }),
  /** Square made no nonce, with its reason (an invalid card number), or the page's. */
  z.object({ type: z.literal('tokenizeFailed'), errorMessage: z.string() }),
]);
export type SquareCardFormMessage = z.output<typeof squareCardFormMessageSchema>;
